export default "data:image/svg+xml,"